import { Injectable, OnDestroy } from '@angular/core';

import { filter } from 'rxjs';
import { TreeNode } from 'primeng/api';

import { RegionSelectDialogService } from '../../../Common/Dialogs/services/region-select-dialog.service';
import { JournodexRegionsService } from '../../../Common/Journodex/services/journodex-regions.service';
import { IncludeOrExclude } from '../../../Common/Dialogs/services/data-select-dialog.service.interface';
import { JournodexGeographyModel } from '../../../Common/Journodex/models/journodex-geography.model';
import { BasicFilterApiModel } from '../../../api/shared/models/basic-filter.api.model';
import { AccountManagementService } from './account-management.service';

@Injectable()
export class PreferencesRegionSelectDialogService extends RegionSelectDialogService implements OnDestroy {

    geographyRestrictions: BasicFilterApiModel<number>;


    constructor(
        protected geographyService: JournodexRegionsService,
        private accountManagementService: AccountManagementService
    ) {
        super(geographyService);
        this.subscriptions.push(
            this.accountManagementService.getTargetingAccountPreferences().pipe(filter(x => !!x)).subscribe(prefs => {
                this.geographyRestrictions = prefs.geography;
            })
        );
    }

    applySelectedListItems(selectedItems: TreeNode[]) {
        if (this.state === undefined) {
            return;
        }
        const newSelectedItems = this.filterOutNodeChildren(selectedItems);
        if (newSelectedItems) {
            this.selectedRegions = newSelectedItems.map(item => item.data) as JournodexGeographyModel[];
            this.geographyRestrictions[this.state] = newSelectedItems.map(item => {
                return item.data.collectionId;
            });
        }
    }

    setAppropriateListItems() {
        if (this.state === undefined) {
            return;
        }
        if (this.geographyRestrictions[this.state]) {
            this.geographyService.getByGeographyIds(this.geographyRestrictions[this.state]).subscribe(regions => {
                this.setSelectedRegions(regions);
            });
        }
    }

    prepareData(state: IncludeOrExclude, regionIds: number[]) {
        this.geographyService.getByGeographyIds(regionIds).subscribe(regions => {
            this.selectedRegions = regions;
            this.geographyRestrictions[state] = regionIds;
            this.setState(state);
        });
    }


    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
